import React, { useEffect } from 'react';
import Tab from '../../Components/Tab/Tab';
import './SettingIndex.scss';
import Setting from './Setting';
import ReceiptSetting from './ReceiptSetting';

//tab route list
const routeList = {
    'tablet': '태블릿 설정',
    'receipt' : '영수증 설정'
}

const SettingIndex = (props) => {
    const [ name, setName ] = React.useState('tablet')//current tab route
    
    //tab route list dict
    const tabRoute = [
        { route : 'tablet', header : '태블릿 설정' },
        { route : 'receipt', header : '영수증 설정' },
    ]

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>설정 {'>'}</p>
                <p className='header'>{routeList[name]}</p>
            </div>
            <Tab 
                routes={tabRoute}
                current={name}
                onTabChange={(name) => setName(name)}
                renderItems={{
                    'tablet' : <Setting />,
                    'receipt' : <ReceiptSetting />,
                }}
            />
        </div>
    )
}

export default SettingIndex;